var _path, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Component_83",
    width: 21.013,
    height: 19.374,
    viewBox: "0 0 21.013 19.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4683",
    d: "M926.889 1563.351a4.611 4.611 0 0 0-6.357-.034 4.221 4.221 0 0 0-1.279 2.757c.173.037.344.078.512.128a3.826 3.826 0 0 1 .041-.409 3.226 3.226 0 0 0 2.369-.521l1.182 1.147-1.176 1.141c.129.115.253.235.372.361l1.176-1.141 1.182 1.147a2.987 2.987 0 0 0-.537 2.3 3.985 3.985 0 0 1-.421.039c.052.163.094.33.132.5a4.46 4.46 0 0 0 2.84-1.242 4.285 4.285 0 0 0-.036-6.173zm-6.972 1.942a3.736 3.736 0 0 1 .806-1.429l1.071 1.04a2.707 2.707 0 0 1-1.877.389zm1.178-1.79a3.937 3.937 0 0 1 1.875-.873 2.52 2.52 0 0 1-.766 1.949zm1.481 1.437a3 3 0 0 0 .917-2.368h.184a4.079 4.079 0 0 1 2.647.969l-2.6 2.519zm1.523 1.478l2.6-2.52a3.815 3.815 0 0 1 .994 2.747 3.2 3.2 0 0 0-2.44.89zm.787 3.7a2.5 2.5 0 0 1 .4-1.822l1.071 1.039a3.915 3.915 0 0 1-1.47.78zm.735-2.219a2.686 2.686 0 0 1 2.009-.743 3.726 3.726 0 0 1-.9 1.819z",
    fill: "currentColor",
    transform: "translate(-907.204 -1558.344)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7712",
    transform: "translate(5.235 8.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4686",
    d: "M919.427 1575.058l.6 1.794 1.733.554 1.616-1.134a5.134 5.134 0 0 0-.875-2.638h-2z",
    fill: "currentColor",
    transform: "translate(-912.502 -1571.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4687",
    d: "M914.346 1580.907l-1.572-1.108-1.735.545-.617 1.838a5.443 5.443 0 0 0 2.31 1.631l1.614-1.137z",
    fill: "currentColor",
    transform: "translate(-909.229 -1573.594)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4690",
    d: "M914.953 1573.209h1.947l1.078-1.428-.616-1.846a5.661 5.661 0 0 0-2.853 0l-.621 1.845z",
    fill: "currentColor",
    transform: "translate(-910.487 -1569.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4691",
    d: "M911.9 1576.844l.6-1.793-1.069-1.434h-2a5.13 5.13 0 0 0-.882 2.636l1.614 1.138z",
    fill: "currentColor",
    transform: "translate(-908.547 -1571.228)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4692",
    d: "M919.162 1579.8l-1.571 1.108v1.769l1.614 1.138a5.453 5.453 0 0 0 2.3-1.62l-.612-1.841z",
    fill: "currentColor",
    transform: "translate(-911.834 -1573.594)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7713",
    transform: "translate(4.878 8.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4695",
    d: "M913.786 1580.444a5.63 5.63 0 1 1 5.8-5.627 5.722 5.722 0 0 1-5.8 5.627zm0-10.719a5.094 5.094 0 1 0 5.249 5.092 5.178 5.178 0 0 0-5.249-5.091z",
    fill: "currentColor",
    transform: "translate(-907.986 -1569.19)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7714",
    transform: "translate(3.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4696",
    d: "M912.778 1556.505l-6.743 7.414 1.1 1.066 7.643-6.542a1.345 1.345 0 0 0 .064-2 1.445 1.445 0 0 0-2.064.062z",
    fill: "currentColor",
    transform: "translate(-906.035 -1556.041)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7715",
    transform: "translate(0 8.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4697",
    d: "M900.966 1571.637a.383.383 0 0 0-.532 0 .356.356 0 0 0 0 .516l1.506 1.462a.385.385 0 0 0 .533 0 .358.358 0 0 0 0-.517l-.22-.214 2.256-2.189-1.065-1.034-2.256 2.189z",
    fill: "currentColor",
    transform: "translate(-900.323 -1569.662)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSport);
export default __webpack_public_path__ + "static/media/sport.3b873968.svg";
export { ForwardRef as ReactComponent };